/** URL pública do portal do cliente (?company=slug). */
export function buildClientPortalPublicUrl(companySlug) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const slug = String(
    companySlug ||
      (typeof window !== "undefined" ? window.localStorage.getItem("company") : "") ||
      ""
  ).trim();
  if (!slug) return `${origin}/portal-cliente`;
  return `${origin}/portal-cliente?company=${encodeURIComponent(slug)}`;
}
